import { create } from 'zustand';

/**
 * O "ligar", alcançável de qualquer tela.
 *
 * Quem disca é a tela de Conversas e quem toca é a moldura da aplicação, onde o aparelho
 * vive — sem um ponto comum, o botão de ligar teria de atravessar meia dúzia de
 * componentes como prop. Fica `null` enquanto o socket não subiu: é o que desabilita o
 * botão em vez de deixá-lo clicável e mudo.
 *
 * Mora aqui, e não junto do componente da chamada: o Fast Refresh do Vite exige que um
 * módulo exporte só componentes para poder trocá-los a quente. Um store no meio deles
 * punha o servidor de desenvolvimento num laço de invalidação — a tela parava de receber
 * as mudanças sem dizer por quê (07/10).
 */
export const useDiscar = create<{
  ligarPara: ((canalId: string, nome: string) => void) | null;
  definir: (ligarPara: ((canalId: string, nome: string) => void) | null) => void;
}>((set) => ({ ligarPara: null, definir: (ligarPara) => set({ ligarPara }) }));
